const ui = {
  background: '#EFEFEF',
  divider: '#383838',
  textPrimary: '#1F2D49',
  textSecondary: '#8B8B8B',
  textLight: '#FFFFFF',
  textAlert: '#A83C38',
  buttonPrimary: '#69B49E',
  buttonPrimaryHover: '#2E9376',
  buttonClose: '#4B4B4B',
  buttonCloseHover: '#1F1F1F',
};

export default { ui };
